import axios from 'axios';
import { baseUrl } from '@/config';

const SMART_ANALYSIS_BASE_URL = `${baseUrl}/smart`;
export default {
  /**
   * hashkeyId 기준으로 자원 정보를 조회한다.
   * @author Ju
   * @param  {Array} hashkeyIds
   * @return {Object}
   */
  getPredictTargetRscByObjRscKey(objRscKeyList) {
    return axios.post(`${SMART_ANALYSIS_BASE_URL}/get-predict-target-rsc-by-obj-rsc-key.do`, objRscKeyList);
  },
  /**
   * seqNumber에 해당하는 이벤트 이력을 조회한다.
   * @author Ju
   * @param  {Array} seqNumbers
   */
  getEventHistBySeqNumbers(seqNumbers) {
    return axios.post(`${SMART_ANALYSIS_BASE_URL}/get-event-hist-by-seq-numbers`, seqNumbers);
  },
  /**
   * seqNumber에 해당하는 이벤트 이력을 조회한다.
   * @author Ju
   * @param  {Array} seqNumbers
   */
  getPredictEventHistBySeqNumbers(seqNumbers) {
    return axios.post(`${SMART_ANALYSIS_BASE_URL}/get-predict-event-hist-by-seq-numbers`, seqNumbers);
  },
  /**
   * 성능 데이터를 예측한다.
   * @author Ju
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  predictPerformance(params) {
    return axios.post(`${SMART_ANALYSIS_BASE_URL}/predict-performance.do`, params);
  },
  /**
   * 성능 데이터 예측 완료 여부를 확인한다.
   * @author Ju
   * @param  {String} predictRequestId 예측 요청 ID
   */
  checkCompletePredictPerformance(predictRequestId) {
    return axios.get(`${SMART_ANALYSIS_BASE_URL}/check-complete-predict-performance.do`, { params: { predictRequestId } });
  },
  /**
   * 성능 예측 결과를 조회한다.
   * @author Ju
   * @param  {String} predictRequestId 예측 요청 ID
   */
  getPerformancePredictReuslt(predictRequestId) {
    return axios.get(`${SMART_ANALYSIS_BASE_URL}/get-performance-predict-result.do`, { params: { predictRequestId } });
  },
  /**
   * 장비의 시뮬레이션 대상 자원을 조회한다.
   * @author Ju
   * @param  {Object} params { objId, managetypeId (objManagetypeId), objtypeId }
   * @return {[type]}        [description]
   */
  getSimulationRscList(params) {
    return axios.post(`${SMART_ANALYSIS_BASE_URL}/get-simulation-rsc-list.do`, params);
  },
  /**
   * 시뮬레이션 예측을 수행한다.
   * @author Ju
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  executeSimulation(params) {
    return axios.post(`${SMART_ANALYSIS_BASE_URL}/execute-simulation.do`, params);
  },
  /**
   * 시뮬레이션 예측 완료 여부를 확인한다.
   * @author Ju
   * @param  {Object} params
   */
  checkCompleteSimulation(params) {
    return axios.post(`${SMART_ANALYSIS_BASE_URL}/check-complete-simulation.do`, params);
  },
  /**
   * 시뮬레이션 예측 결과를 조회한다.
   * @author Ju
   * @param  {Object} params
   */
  getSimulationResult(params) {
    return axios.post(`${SMART_ANALYSIS_BASE_URL}/get-simulation-result.do`, params);
  },
  /**
   * 장애근원지 분석 로드
   * @author yelim
   */
  getRootCauseAnalysisData(params) {
    return axios.get(`${SMART_ANALYSIS_BASE_URL}/get-root-cause-analysis-data.do`, { params });
  },
  /**
   * 장애 근원지 이벤트 분석 상관관계 맵 데이터 조회
   * @author jeee12
   * @param  {[type]} params [description]
   */
  getRcaEventCorrelationMapData(params) {
    return axios.post(`${SMART_ANALYSIS_BASE_URL}/get-rca-event-correlation-map-data.do`, params);
  },
};



// WEBPACK FOOTER //
// ./src/api/common/smart-analysis.js